import {
  Accordion,
  Badge,
  Button,
  Card,
  Container,
  ListGroup,
  Row,
  Stack,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function AnkietaListItem({ survey }) {
  const navigate = useNavigate();

  let label = "Czeka na wypełnienie";
  let color = "primary";

  switch (survey.surveyStatus) {
    case 0:
      label = "Czeka na wypełnienie";
      color = "secondary";
      break;
    case 1:
      label = "W trakcie wypełniania";
      color = "primary";
      break;
    case 2:
    case 3:
      label = "Wypełniona";
      color = "success";
      break;
  }

  const surveyStatus = {
    label: label,
    color: color,
  };

  return (
    <ListGroup.Item
      as="li"
      className="d-flex justify-content-between align-items-center"
    >
      <div className="ms-2 me-auto">
        <div className="fw-bold">
          {survey.title}{" "}
          <Badge bg={surveyStatus.color} pill>
            {surveyStatus.label}
          </Badge>
        </div>
        {/* {metadata.description} */}
      </div>

      {survey.surveyStatus < 2 && (
        <Button
          onClick={() => navigate("/pacjent/ankiety/" + survey.instanceId)}
          className="p-2 ms-auto"
          variant="link"
          size="sm"
        >
          Przejdź do ankiety
        </Button>
      )}
    </ListGroup.Item>
  );
}
